module.exports = __webpack_public_path__ + "static/consult_res-634d5c059ec078afed8a203e09433dc0.jpg";